import produce from "immer";
import { createAction } from "redux-smart-actions";
import { createSelector } from "reselect";
import { KomutRedux } from "../base/types/KomutRedux";
import { RootState } from "../base/types/RootState";
import { LanguageModel } from "./types";

const SET_LANGUAGE = "SET_LANGUAGE";
const SET_LANGUAGES = "SET_LANGUAGES";
const GET_LANGUAGES = "GET_LANGUAGES";

export interface LanguageReducer {
  languages: LanguageModel[];
  language: LanguageModel;
}

export interface LanguageActions {
  setLanguage: (payload: LanguageModel) => {};
  setLanguages: any;
  getLanguages: any;
}

const languageRedux = new KomutRedux<LanguageReducer, LanguageActions>();

languageRedux.setInitialState({
  language: {
    Code: "en-US",
    EnumId: "73338890-d4e0-4976-90ed-6953286a824f",
    Name: "English",
  },
  languages: [
    {
      Code: "en-US",
      EnumId: "73338890-d4e0-4976-90ed-6953286a824f",
      Name: "English",
    },
    {
      Code: "tr-TR",
      EnumId: "71173a68-8b7c-4560-bbb6-d98d7817b5aC",
      Name: "Türkçe",
    },
    {
      Code: "de-DE",
      EnumId: "1a991b84-41cb-428d-85da-26b0c266d7b9",
      Name: "German",
    },
    {
      Code: "it-IT",
      EnumId: "bc82e4bc-012a-4c85-83d9-66b25aed3f4d",
      Name: "Italian",
    },
    {
      Code: "fr-FR",
      EnumId: "7a6562c9-6599-49cb-90be-886536aa8dd5",
      Name: "French",
    },
    {
      Code: "es-ES",
      EnumId: "42937dc7-8c74-4993-a531-55607ad7e599",
      Name: "Spanish",
    },
  ],
});

languageRedux.setActions({
  setLanguages: createAction(SET_LANGUAGES, (payload: LanguageModel[]) => ({
    payload,
  })),
  setLanguage: createAction(SET_LANGUAGE, (payload: LanguageModel) => ({
    payload,
  })),
  getLanguages: createAction(GET_LANGUAGES),
});

languageRedux.setRedusers(
  produce((draft: LanguageReducer, action: any) => {
    switch (action.type) {
      case SET_LANGUAGE:
        draft.language = action.payload;
        break;
      case SET_LANGUAGES:
        draft.languages = action.payload;
        break;
    }
  }, languageRedux.initialState)
);

// ** SELECTORS *** \\
const languageState = (state: RootState) => state.language.language;
export const languageSelector = createSelector(
  [languageState],
  (state) => state
);

const languagesState = (state: RootState) => state.language.languages;
export const languagesSelector = createSelector(
  [languagesState],
  (state) => state
);

export default languageRedux;
